import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ViewCell } from '../ofbiz-form-model';

@Component({
  template: `
  <nb-checkbox (checkedChange)="toggle($event)" [checked]="checked" disabled></nb-checkbox>
  `,
})
export class OfbizCellCheckComponent implements ViewCell, OnInit, OnChanges {
  @Input() value: string | number;
  @Input() rowData: any;
  checked = false;
  
  constructor() { }

  ngOnInit(): void {
    console.log({RowData:this.rowData});
    this.checked = this.rowData.checkbox;
  }

  

  toggle(checked: boolean) {
    this.checked = checked;
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["value"]){
      console.log({ValueChange:this.value});
     if(this.value == "true"){
      this.toggle(true)
     }else{
      this.toggle(false);
     }
    }
  }
  setValue(data,cell){
    console.log({SettingValue:data,Cell:cell});
  }

}
